<template>
  <div class="sk-wrap" role="status" aria-label="Loading">
    <table class="sk-table">
      <thead v-if="header">
        <tr>
          <th v-for="c in colCount" :key="'h' + c">
            <span class="sk-bar sk-head" :style="barStyle(c, true)"></span>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="r in rows" :key="'r' + r">
          <td v-for="c in colCount" :key="'c' + r + '-' + c">
            <span class="sk-bar" :style="barStyle(c)"></span>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
/**
 * Lightweight shimmer placeholder for tables. Drop it in while a list is loading
 * instead of the full-screen blocking spinner:
 *
 *   <SkeletonTable v-if="loading" :rows="8" :cols="6" />
 *   <table v-else> ...real rows... </table>
 *
 * Globally registered in main.js, so no per-file import is needed.
 */
export default {
  name: "SkeletonTable",
  props: {
    rows: { type: Number, default: 6 },
    cols: { type: Number, default: 5 },
    header: { type: Boolean, default: true },
  },
  computed: {
    colCount() {
      return Math.max(1, this.cols);
    },
  },
  methods: {
    // Vary widths a little so it reads like real data, deterministically per column.
    barStyle(c, isHead = false) {
      const widths = isHead
        ? [55, 45, 50, 40, 60, 45, 50]
        : [80, 60, 70, 45, 90, 55, 65];
      const w = widths[(c - 1) % widths.length];
      return { width: w + "%" };
    },
  },
};
</script>

<style scoped>
.sk-wrap {
  width: 100%;
  overflow: hidden;
}
.sk-table {
  width: 100%;
  border-collapse: collapse;
}
.sk-table th,
.sk-table td {
  padding: 14px 10px;
  border-bottom: 1px solid #f0f0f0;
  text-align: left;
}
.sk-bar {
  display: block;
  height: 12px;
  border-radius: 6px;
  background: linear-gradient(
    90deg,
    #eceff3 25%,
    #f6f7f9 37%,
    #eceff3 63%
  );
  background-size: 400% 100%;
  animation: sk-shimmer 1.2s ease-in-out infinite;
}
.sk-head {
  height: 10px;
  background: linear-gradient(
    90deg,
    #e2e6eb 25%,
    #eef0f3 37%,
    #e2e6eb 63%
  );
  background-size: 400% 100%;
}
@keyframes sk-shimmer {
  0% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0 50%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .sk-bar {
    animation: none;
  }
}
</style>
